export default class RejMessages {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new RejMessages;
		self.attachEvents();
	}

	static success(msg) {
		const self = new RejMessages;
		self.displaySuccessMessage(msg);
	}

	static error(msg) {
		const self = new RejMessages;
		self.displayErrorMessage(msg);
	}

	static remove() {
		const self = new RejMessages;
		self.removeMessage();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-close-message', function(e) {
			e.preventDefault();
			self.removeMessage();
		});
	}

	displaySuccessMessage(msg) {
		const self = this;
		self.displayMessage(msg, 'success');
	}

	displayErrorMessage(msg) {
		const self = this;
		self.displayMessage(msg, 'danger');
	}

	displayMessage(msg, type) {
		const self = this,
			message = '<div class="form-response form-error-message alert alert-' + type + '">' + msg + '<a href="#" class="form-response-close js-close-message"></a></div>';

		$('.form-fixed-response').remove();

		$('body').append('<div class="form-fixed-response"><div class="container">' + message + '</div></div>');
        $('.form-fixed-response').fadeIn(200);

         // remove fixed error message after 5 secs
	    setTimeout(function() {
	        self.removeMessage();
	    }, 5000);
	}

	removeMessage() {
		const self = this;

		$('.form-fixed-response').fadeOut(200, function(){
			$(this).remove();
		});
	}
}
